import axios from 'axios';

const API_BASE = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api').replace(/\/$/, '');
const API_URL = `${API_BASE}/auth`;

const login = async (username, password) => {
    // FastAPI espera los datos de login en un formato de formulario
    const formData = new URLSearchParams();
    formData.append('username', username);
    formData.append('password', password);

    const response = await axios.post(`${API_URL}/token`, formData, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });

    if (response.data.access_token) {
        localStorage.setItem('user_token', JSON.stringify(response.data));
    }
    return response.data;
};

const logout = () => {
    localStorage.removeItem('user_token');
};

const getCurrentToken = () => {
    const tokenStr = localStorage.getItem('user_token');
    if (tokenStr) return JSON.parse(tokenStr);
    return null;
};

const authService = {
    login,
    logout,
    getCurrentToken,
};

export default authService;